import React, { useEffect, useState } from 'react';
import { API_BASE_URL, getAuthHeaders } from '../utils/api';

/**
 * YUML attachment config editor — used on prompts, tools, and projects.
 */
export default function YumlConfigFields({
  value,
  onChange,
  suffix,
  summaryKeyOptions = [],
  emitOn = 'after_output',
}) {
  const cfg = value && typeof value === 'object' ? value : {};
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!suffix) return;
    let cancelled = false;
    (async () => {
      setLoading(true);
      try {
        const headers = await getAuthHeaders();
        const resp = await fetch(
          `${API_BASE_URL}/casc/v1/api/yuml/suffixes/${encodeURIComponent(suffix)}`,
          { headers }
        );
        const json = await resp.json();
        if (!cancelled && json.success) setTemplates(json.data || []);
      } catch (_) {
        if (!cancelled) setTemplates([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [suffix]);

  const update = (patch) => {
    onChange({ ...cfg, emit_on: emitOn, ...patch });
  };

  return (
    <div className="yuml-config-fields">
      <label className="checkbox-row">
        <input
          type="checkbox"
          checked={!!cfg.enabled}
          onChange={(e) => update({ enabled: e.target.checked })}
        />
        Enable YUML formatted output
      </label>
      {cfg.enabled && (
        <>
          <div className="form-group">
            <label htmlFor="yuml-template-select">YUML template</label>
            <select
              id="yuml-template-select"
              value={cfg.template_id || ''}
              onChange={(e) => update({ template_id: e.target.value || null })}
              disabled={loading}
            >
              <option value="">— Select template —</option>
              {templates.map((t) => (
                <option key={t.id} value={t.id}>{t.name} ({t.slug})</option>
              ))}
            </select>
          </div>
          {summaryKeyOptions.length > 0 && (
            <div className="form-group">
              <label htmlFor="yuml-summary-keys">Summary keys (chat preview)</label>
              <select
                id="yuml-summary-keys"
                multiple
                value={Array.isArray(cfg.summary_keys) ? cfg.summary_keys : []}
                onChange={(e) => {
                  const selected = Array.from(e.target.selectedOptions).map((o) => o.value);
                  update({ summary_keys: selected });
                }}
              >
                {summaryKeyOptions.map((k) => (
                  <option key={k} value={k}>{k}</option>
                ))}
              </select>
              <small className="form-help">Hold Ctrl/Cmd to select multiple keys.</small>
            </div>
          )}
        </>
      )}
    </div>
  );
}
